
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../UserPermissions.js";
import { Permission, Permissions_allowsReceiverType } from "../../../Shared/Roles.js";
import { ReceiverTypeName } from "../../../Shared/User.js";
import { inspectionStatusColumnDefinition, buildInspectionLookup } from "../InspectionHelper.js";
import { SWR_getToolBoxes } from "../../../Requests/Toolbox.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, toArray, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SelectedTab, ToolboxControl } from "../../../Widgets/ToolboxControlWidget.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { Feature, isFeatureEnabled } from "../../../FeatureFlip.js";
import { unwrap, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Table_customPropertyColumnDefinitions } from "../../../Widgets/CustomProperties.js";
import { InfiniteTable } from "../../../Widgets/Table/InfiniteTable.js";
import { filter, ofArray, singleton as singleton_1, toArray as toArray_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../../Common.js";
import User_Add_Plus from "../../../../public/assets/icons/User_Add_Plus.svg";
import { TableControlElement$1, TableControl$1 } from "../../../Widgets/Table/Table.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { PropertyConfigurationVisibility } from "../../../Shared/PropertyConfiguration.js";
import { Skeleton } from "../../../Components/Skeleton.js";

export function SchoolClassOverviewTable(props) {
    let elems;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canReadReceivers = Permissions_allowsReceiverType(permissions, new Permission(41, []), new ReceiverTypeName(8, []));
    const canCreateReceivers = Permissions_allowsReceiverType(permissions, new Permission(42, []), new ReceiverTypeName(8, []));
    const inspectionLookup = buildInspectionLookup(SWR_getToolBoxes().data);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = toList(delay(() => (canReadReceivers ? append(singleton(createElement(ToolboxControl, {
        CustomerConfiguration: props.CustomerConfiguration,
        SelectedTab: new SelectedTab(9, []),
        UserData: props.UserData,
    })), delay(() => {
        let TableRows, Options;
        const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? singleton(inspectionStatusColumnDefinition(inspectionLookup, (dto_1) => dto_1.Id, t)) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton(new ColumnDefinition$1("email", "", t("general.email"), (dto_2) => {
            const matchValue = dto_2.Email;
            return (matchValue == null) ? (new CellContent(0, [""])) : (new CellContent(0, [matchValue]));
        }, "text", "text")) : empty(), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_3) => (new CellContent(0, [defaultArg(dto_3.BusinessUnitName, "")])), "select", "text")) : empty(), delay(() => append(isFeatureEnabled(new Feature(6, [])) ? singleton(new ColumnDefinition$1("archived", "", t("user.is_archived"), (dto_4) => (new CellContent(0, [dto_4.IsArchived ? t("general.yes") : t("general.no")])), "select", "text")) : empty(), delay(() => Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto_5) => dto_5.CustomProperties, t, props.CustomerConfiguration.Currency)))))))))))));
        return singleton(createElement(InfiniteTable, (TableRows = toArray_1(props.SchoolClasses), (Options = {
            BorderStyle: "row",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultColumnFilter: unwrap(isFeatureEnabled(new Feature(6, [])) ? singleton_1({
                id: "archived",
                value: [t("general.no")],
            }) : undefined),
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(dto_6) => RouterModule_encodeParts(ofArray(["receivers", "school-classes", dto_6.Id + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: true,
        }, {
            ColumnDefinitions: columnDefinitions,
            Controls: toList(delay(() => (canCreateReceivers ? singleton(new TableControlElement$1(0, [new TableControl$1(t("school_class.create_new_school_class"), User_Add_Plus(), (_arg) => {
                RouterModule_nav(ofArray(["receivers", "school-classes", "new" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
            }, false, false, "receiver-create")])) : empty()))),
            Options: Options,
            TableKey: "receiver-school-class-overview-table",
            TableRows: TableRows,
        }))));
    })) : empty()))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function SchoolClassOverviewView(props) {
    const state_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined)[0];
    const matchValue = state_1.SchoolClasses;
    const matchValue_1 = state_1.CustomerConfiguration;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.AccountSettings;
    let matchResult, accountSettings, customerConfiguration, propertyConfigurations, schoolClasses;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        customerConfiguration = matchValue_1.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        schoolClasses = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(SchoolClassOverviewTable, {
                AccountSettings: accountSettings,
                CustomerConfiguration: customerConfiguration,
                PropertyConfigurations: filter((propertyConfiguration) => equals(propertyConfiguration.Visibility, new PropertyConfigurationVisibility(11, [])), propertyConfigurations),
                SchoolClasses: schoolClasses,
                UserData: props.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

